class Autofocuser
  constructor: (@$elm, @events)->
    return unless @$elm.length
    @$elm.find("input").filter(-> this.value == "").first().focus()

module.exports = Autofocuser
